namespace RedBullMOBILE360.PushNotifications {
    export namespace PushNotificationsPGService {
        export const baseUrl = 'PushNotifications/PushNotificationsPG';

        export declare function Create(request: Serenity.SaveRequest<PushNotificationsPGRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PushNotificationsPGRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PushNotificationsPGRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PushNotificationsPGRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PushNotifications/PushNotificationsPG/Create",
            Update = "PushNotifications/PushNotificationsPG/Update",
            Delete = "PushNotifications/PushNotificationsPG/Delete",
            Retrieve = "PushNotifications/PushNotificationsPG/Retrieve",
            List = "PushNotifications/PushNotificationsPG/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PushNotificationsPGService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
